@if (resAsync | async) {
  <div class="containerStepper">
    <div fxLayout="column" fxLayoutAlign="center none">
      <div class="headerHelp" fxLayout="row" fxLayoutAlign="end none">
        <button
          id="selectHelpButton"
          mat-icon-button
          matTooltip="res.get('OpenHelpLink')"
          aria-label="res.get('SelectHelp')"
          (click)="openHelp()"
        >
          <mat-icon [svgIcon]="res.svgName('Help-Image')" class="helpIcon"></mat-icon>
        </button>
      </div>
      <div class="center">
        <mat-vertical-stepper #stepper [linear]="isLinear" (selectionChange)="stepSelectionChange($event)">
          <mat-step #stepWelcome state="chat" [editable]="isEditable" [label]="welcomeStepLabel">
            <div style="display: flex">
              <div fxLayout="row" fxLayoutAlign="space-between center" style="width: 600px">
                <div>
                  <h1>{{ res.get('WorkGroupsConfiguration') }}</h1>
                </div>
              </div>
            </div>
            <div fxLayout="row">
              <div fxLayoutAlign="center center">
                <p>
                  {{ res.get('WorkGroupsConfigurationDescription') }}
                </p>
              </div>
            </div>
            <div class="work-group-selection-mode">
              <mat-radio-group aria-label="Select an option" [(ngModel)]="selectedMode">
                <mat-radio-button value="evaluate">{{ res.get('EvaluateMaintenanceCycles') }} </mat-radio-button>
                <mat-radio-button value="createNew">{{ res.get('CreateNewWorkGroup') }}</mat-radio-button>
                <mat-radio-button value="editExisting">{{ res.get('EditExistingWorkGroup') }}</mat-radio-button>
              </mat-radio-group>
            </div>
            <hr />
            <div fxLayout="row" style="float: right">
              <div fxFlex="30">
                <button mat-button matStepperNext>{{ res.get('ButtonTextContinue') }}</button>
              </div>
            </div>
          </mat-step>
          <mat-step
            #stepSourceData
            [label]="selectedMode !== 'evaluate' ? res.get('LabelSourceData') : res.get('LabelSelectWorkTemplate')"
            state="chat"
            [editable]="isEditable"
            completed="false"
          >
            <p>
              {{
                selectedMode === 'evaluate'
                  ? res.get('EvaluateMaintenanceCyclesDescription')
                  : selectedMode === 'createNew'
                    ? res.get('SourceDataWorkGroupsConfiguration')
                    : selectedMode === 'editExisting'
                      ? res.get('SelectWorkGroupDescription')
                      : ''
              }}
            </p>
            @if (selectedMode === 'evaluate') {
              <div>
                <div fxLayout="column" fxLayoutAlign="space-between start">
                  <div style="height: 290px; width: 400px">
                    @if (
                      {
                        objectSelectionGroups: (workTemplateSelectionGroups$ | async),
                        isLoadingGroups: (isLoadingWorkTemplateGroups$ | async),
                      };
                      as objSelectionObservables
                    ) {
                      <div>
                        @if (
                          !objSelectionObservables.isLoadingGroups && objSelectionObservables.objectSelectionGroups
                        ) {
                          @if (objSelectionObservables.objectSelectionGroups.length === 0) {
                            <div>
                              <div class="fullPageContainer" fxFill fxLayout="row" fxLayoutAlign="center center">
                                {{ res.get('ErrorAtSelectionOfWorkTemplates') }}
                              </div>
                            </div>
                          }
                          @if (objSelectionObservables.objectSelectionGroups.length > 0) {
                            <div fxLayout="row" fxLayoutAlign="center center">
                              <div style="height: 300px">
                                <abc-object-selection-group
                                  #worktemplateSelectionComponent
                                  [groups]="objSelectionObservables.objectSelectionGroups"
                                  [isObjectSetVisible]="false"
                                >
                                </abc-object-selection-group>
                              </div>
                            </div>
                          }
                        } @else {
                          <div class="fullPageContainer" fxFill fxLayout="row" fxLayoutAlign="center center">
                            <dx-load-indicator ngClass="task-icon" ngClass.lt-sm="task-icon small"> </dx-load-indicator
                            >{{ res.get('WorkTemplatesWillBeLoaded') }}
                          </div>
                        }
                      </div>
                    }
                  </div>
                  <abc-drop-down-box
                    class="maintenanceCycleEvaluationSpacer"
                    (onValueChanged)="onStatusChanged($event)"
                    [label]="res.get('WorkStatus')"
                    [labelMode]="'floating'"
                    [width]="'400px'"
                    [height]="'40px'"
                    [dataSource]="statusData"
                    displayExpr="Description"
                    valueExpr="Value"
                    [hideColumnHeaders]="true"
                    [isValid]="!!arbeitStatusText"
                    [validationError]="!arbeitStatusText ? { message: arbeitStatusValidationMessage } : null"
                    [gridColumns]="[
                      {
                        dataField: 'Description',
                        name: 'Description',
                      },
                    ]"
                  ></abc-drop-down-box>
                </div>
              </div>
            }
            @if (selectedMode === 'createNew') {
              <div>
                <div fxLayout="column" fxLayoutAlign="space-between start" class="workGroupCreationSpacer">
                  <abc-text-box
                    [label]="res.get('WorkGroupDesignation')"
                    [labelMode]="'floating'"
                    valueChangeEvent="keyup"
                    (onValueChanged)="onDesignationChanged($event)"
                    [width]="'400px'"
                    [height]="'40px'"
                    [(value)]="designation"
                  >
                  </abc-text-box>
                  <abc-drop-down-box
                    (onValueChanged)="onGroupTemplateChanged($event)"
                    [dataSource]="groupTemplateData"
                    [height]="'40px'"
                    [labelMode]="'floating'"
                    [label]="res.get('GroupTemplate')"
                    [width]="'400px'"
                    displayExpr="Description"
                    valueExpr="Id"
                    [hideColumnHeaders]="true"
                    [(value)]="selectedGroupTypeId"
                    [gridColumns]="[
                      {
                        dataField: 'Description',
                        name: 'Description',
                      },
                    ]"
                  ></abc-drop-down-box>
                  <abc-check-box
                    class="maintenance-checkbox"
                    [text]="res.get('CreateMaintenanceCycle')"
                    [(value)]="isMaintenanceCycleChecked"
                    (onValueChanged)="onMaintenanceCycleChanged($event)"
                  ></abc-check-box>
                  <div fxLayout="row" fxLayoutGap="4px">
                    <abc-number-box
                      [label]="res.get('Interval')"
                      [mode]="'number'"
                      [width]="'400px'"
                      [height]="'40px'"
                      [(value)]="cycleLength"
                      (onValueChanged)="onCycleLengthChanged($event)"
                      [showClearButton]="true"
                      [stylingMode]="'filled'"
                      valueChangeEvent="keyup"
                      [disabled]="!isMaintenanceCycleChecked"
                    ></abc-number-box>
                    <abc-drop-down-box
                      (onValueChanged)="onCycleUnitChanged($event)"
                      [(value)]="selectedCycleUnitId"
                      [dataSource]="cycleUnitList"
                      [height]="'40px'"
                      [labelMode]="'floating'"
                      [label]="res.get('CycleUnit')"
                      [width]="'400px'"
                      displayExpr="Description"
                      valueExpr="Id"
                      [hideColumnHeaders]="true"
                      [gridColumns]="[
                        {
                          dataField: 'Description',
                          name: 'Description',
                        },
                      ]"
                      [disabled]="!isMaintenanceCycleChecked"
                    ></abc-drop-down-box>
                  </div>
                  <div fxLayout="row" fxLayoutGap="4px">
                    <abc-date-box
                      [label]="res.get('FirstExecution')"
                      [labelMode]="'floating'"
                      [width]="'400px'"
                      [height]="'40px'"
                      [(value)]="firstExecutionDate"
                      (onChange)="onFirstExecDateChanged($event)"
                      [disabled]="!isMaintenanceCycleChecked"
                      [acceptCustomValue]="false"
                      [openOnFieldClick]="true"
                    >
                    </abc-date-box>
                    <abc-number-box
                      [label]="res.get('PlanningLeadTime')"
                      [mode]="'number'"
                      [width]="'400px'"
                      [height]="'40px'"
                      [(value)]="leadTime"
                      [format]="leadTimeFormat"
                      (onValueChanged)="onLeadTimeChanged($event)"
                      [stylingMode]="'filled'"
                      valueChangeEvent="keyup"
                      [disabled]="!isMaintenanceCycleChecked"
                    ></abc-number-box>
                  </div>
                </div>
              </div>
            }
            @if (selectedMode === 'editExisting') {
              <div>
                <div fxLayout="column" fxLayoutAlign="space-between start" class="workGroupEditingSpacer">
                  <abc-drop-down-box
                    (onValueChanged)="onWorkGroupChanged($event)"
                    [label]="res.get('WorkGroupSelection')"
                    [labelMode]="'floating'"
                    [width]="'400px'"
                    [height]="'40px'"
                    displayExpr="Description"
                    valueExpr="Id"
                    [dataSource]="workGroupData"
                    [(value)]="selectedAnlageGroupId"
                    [gridColumns]="[{ dataField: 'Description', name: 'Description' }]"
                    [hideColumnHeaders]="true"
                  ></abc-drop-down-box>
                  <abc-check-box
                    class="maintenance-checkbox"
                    [text]="res.get('CreateMaintenanceCycle')"
                    [(value)]="isExistingWorkGroupMaintenanceCycleChecked"
                    (onValueChanged)="onExistingWorkGroupMaintenanceCycleChanged($event)"
                  ></abc-check-box>
                  <div fxLayout="row" fxLayoutGap="4px">
                    <abc-number-box
                      [label]="res.get('Interval')"
                      [mode]="'number'"
                      [width]="'400px'"
                      [height]="'40px'"
                      [(value)]="existingWorkGroupCycleLength"
                      (onValueChanged)="onExistingWorkGroupCycleLengthChanged($event)"
                      [showClearButton]="true"
                      [stylingMode]="'filled'"
                      valueChangeEvent="keyup"
                      [disabled]="!isExistingWorkGroupMaintenanceCycleChecked"
                    ></abc-number-box>
                    <abc-drop-down-box
                      (onValueChanged)="onExistingWorkGroupCycleUnitChanged($event)"
                      [(value)]="existingWorkGroupCycleUnitId"
                      [dataSource]="cycleUnitList"
                      [height]="'40px'"
                      [labelMode]="'floating'"
                      [label]="res.get('CycleUnit')"
                      [width]="'400px'"
                      displayExpr="Description"
                      valueExpr="Id"
                      [hideColumnHeaders]="true"
                      [gridColumns]="[
                        {
                          dataField: 'Description',
                          name: 'Description',
                        },
                      ]"
                      [disabled]="!isExistingWorkGroupMaintenanceCycleChecked"
                    ></abc-drop-down-box>
                  </div>
                  <div fxLayout="row" fxLayoutGap="4px">
                    <abc-date-box
                      [label]="res.get('FirstExecution')"
                      [labelMode]="'floating'"
                      [width]="'400px'"
                      [height]="'40px'"
                      [(value)]="firstExecutionDate"
                      (onChange)="onFirstExecDateChanged($event)"
                      [disabled]="!isExistingWorkGroupMaintenanceCycleChecked"
                      [acceptCustomValue]="false"
                      [openOnFieldClick]="true"
                    >
                    </abc-date-box>
                    <abc-number-box
                      [label]="res.get('PlanningLeadTime')"
                      [mode]="'number'"
                      [width]="'400px'"
                      [height]="'40px'"
                      [(value)]="existingWorkGroupLeadTime"
                      [format]="leadTimeFormat"
                      (onValueChanged)="onExistingWorkGroupLeadTimeChanged($event)"
                      [stylingMode]="'filled'"
                      valueChangeEvent="keyup"
                      [disabled]="!isExistingWorkGroupMaintenanceCycleChecked"
                    ></abc-number-box>
                  </div>
                </div>
              </div>
            }
            <br />
            <hr />
            <div class="step-buttons">
              <button mat-button matStepperPrevious>{{ res.get('ButtonTextBack') }}</button>
              <button mat-button (click)="validateStep(stepSourceData)">{{ res.get('ButtonTextContinue') }}</button>
            </div>
          </mat-step>
          <mat-step
            #stepObjectSelection
            [label]="
              selectedMode !== 'evaluate' ? res.get('LabelObjectSelection') : res.get('LabelEvaluateObjectSelection')
            "
            state="chat"
            [editable]="isEditable"
          >
            <p>
              {{
                selectedMode === 'evaluate'
                  ? res.get('EvaluateObjectSelectionDescription')
                  : selectedMode === 'createNew'
                    ? res.get('CreateNewObjectSelectionDescription')
                    : selectedMode === 'editExisting'
                      ? res.get('EditExistingObjectSelectionDescription')
                      : ''
              }}
            </p>
            @if (
              {
                objectSelectionGroups: (objectSelectionGroups$ | async),
                isLoadingGroups: (isLoadingGroups$ | async),
              };
              as objSelectionObservables
            ) {
              <div>
                @if (!objSelectionObservables.isLoadingGroups && objSelectionObservables.objectSelectionGroups) {
                  @if (objSelectionObservables.objectSelectionGroups.length === 0) {
                    <div>
                      <div class="fullPageContainer" fxFill fxLayout="row" fxLayoutAlign="center center">
                        {{ res.get('ErrorAtSelectionOfAssetsCandidates') }}
                      </div>
                    </div>
                  }
                  <div fxLayout="row" fxLayoutAlign="center center">
                    <div style="height: 500px; width: 100%">
                      <abc-object-selection-group
                        #groupSelectionComponent
                        [groups]="objSelectionObservables.objectSelectionGroups"
                        (itemsCount)="countAssets($event)"
                      >
                      </abc-object-selection-group>
                    </div>
                  </div>
                } @else {
                  <div class="fullPageContainer" fxFill fxLayout="row" fxLayoutAlign="center center">
                    <dx-load-indicator ngClass="task-icon" ngClass.lt-sm="task-icon small"> </dx-load-indicator
                    >{{ res.get('AssetsWillBeLoaded') }}
                  </div>
                }
              </div>
            }
            <hr />
            <div fxLayout="row" fxLayoutAlign="space-between center">
              <div class="items-count">
                <p>
                  {{ res.get('SelectedAssetsCount') }}: <span>{{ assetsCount }}</span>
                </p>
              </div>
              <div class="step-buttons">
                <button mat-button matStepperPrevious>{{ res.get('ButtonTextBack') }}</button>
                <button mat-button matStepperNext>{{ res.get('ButtonTextContinue') }}</button>
              </div>
            </div>
          </mat-step>
          <mat-step [label]="res.get('LabelCheckData')" state="chat" [editable]="isEditable">
            <div>
              <p>{{ dataCheckTitle }}</p>
            </div>
            @if (displayBusybar) {
              <div>
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
              </div>
            }
            <div class="step-buttons">
              <button mat-button class="back-button" (click)="moveBack()" [disabled]="buttonStatus || !isEditable">
                {{ res.get('ButtonTextBack') }}
              </button>
              <button mat-button (click)="executeObjectGroupAction()" [disabled]="buttonStatus">
                <span>{{ buttonText }}</span>
              </button>
            </div>
          </mat-step>
        </mat-vertical-stepper>
      </div>
    </div>
  </div>
}
